<div class="w-full flex flex-col gap-4 p-4">
    <h1 class="text-2xl font-bold">Produtos</h1>

    <app-painel [opened]="false" title="Filtros Avançados">
        <div
            class="w-full grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 items-end p-4"
        >
            <app-select
                label="Grupo"
                [options]="selectGrupo"
                [(ngModel)]="grupo"
            ></app-select>

            <app-select
                label="Categoria"
                [options]="selectCategoria"
                [(ngModel)]="categoria"
            ></app-select>

            <app-select
                label="SubCategoria"
                [options]="selectSubCategoria"
                [(ngModel)]="subCategoria"
            ></app-select>

            <app-select
                label="Marca"
                [options]="selectMarca"
                [(ngModel)]="marca"
            ></app-select>

            <app-input label="NCM" [(ngModel)]="ncm"></app-input>

            <app-input label="Cst PIS" [(ngModel)]="cstPis"></app-input>

            <app-input label="Cst IPI" [(ngModel)]="cstIpi"></app-input>

            <app-input label="Nat. PIS" [(ngModel)]="natPis"></app-input>
        </div>
    </app-painel>

    <div
        class="w-full grid lg:grid-cols-[2fr_1fr_1fr_1fr_auto] md:grid-cols-2 grid-cols-1 gap-4 items-end"
    >
        <app-input
            id="pesquisa"
            label="Pesquisar Produto"
            placeholder="Digite parte do nome do produto, código de barras ou código interno"
            [(ngModel)]="textoPesquisa"
            (onKeypress)="pressionaEnter($event)"
        ></app-input>

        <app-input label="Inicia Com" [(ngModel)]="iniciaCom"></app-input>

        <app-input label="Contém" [(ngModel)]="contem"></app-input>

        <app-input label="Não Contém" [(ngModel)]="naoContem"></app-input>

        <app-button
            icon="fa fa-search"
            [fullWidth]="false"
            class="md:w-12 w-full"
            (click)="carregarLista()"
        ></app-button>
    </div>

    <div class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end">
        <app-button
            (click)="updateGrupo()"
            class="md:max-w-45 w-full"
            >Atualizar Grupo</app-button
        >

        <app-button
            (click)="updateMarca()"
            class="md:max-w-45 w-full"
            >Atualizar Marca</app-button
        >

        <app-button
            (click)="updateOutros()"
            class="md:max-w-45 w-full"
            >Atualizar Outros</app-button
        >
    </div>

    <p-table
        [paginator]="true"
        [(rows)]="qtdLinhas"
        [totalRecords]="totalItens"
        [value]="lista"
        [lazy]="true"
        (onLazyLoad)="lazyLoad($event)"
        [rowsPerPageOptions]="[100, 200, 300, 400, 500, 1000]"
        [(selection)]="selected"
        dataKey="Id"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[3%] min-w-10">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th class="w-[14%] min-w-30">Gtin</th>
                <th class="w-[30%] min-w-30">Nome</th>
                <th class="w-[14%] min-w-30">Grupo</th>
                <th class="w-[9%] min-w-20">NCM</th>
                <th class="w-[9%] min-w-20">CST Pis</th>
                <th class="w-[9%] min-w-20">Taxa IPI</th>
                <th class="w-[7%] min-w-20">CEST</th>
                <th class="w-[5%] min-w-10">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData">
                <td>
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                </td>
                <td>{{ rowData.Gtin }}</td>
                <td>{{ rowData.Nome }}</td>
                <td>{{ rowData.Grupo }}</td>
                <td>{{ rowData.Ncm }}</td>
                <td>{{ rowData.CstPis }}</td>
                <td>{{ rowData.TaxaIpi }}</td>
                <td>{{ rowData.Cest }}</td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-confirmDialog
    header="Confirmação"
    icon="pi pi-exclamation-triangle"
    styleClass="max-w-[90%]"
></p-confirmDialog>

<app-modal-update-produto
    [modalVisible]="modalUpdateProduto"
    [listProduto]="selected"
    [typeUpdate]="type"
    [selectGrupo]="selectGrupo"
    [selectMarca]="selectMarca"
    [selectSubCategoria]="selectSubCategoria"
    [selectDepartamento]="selectDepartamento"
    (closeModal)="modal()"
></app-modal-update-produto>
